import React, { Component } from 'react';
import NavigationDrawer from 'react-md/lib/NavigationDrawers';
import { NotificationContainer } from 'react-notifications';
import { IndexLink, Link } from 'react-router';
import apiRequestService from '../component/ApiRequestService';
//Arun Shankar - Adding BreadCrumb Component Import - 05/01/2018
import BreadCrumb from '../component/BreadCrumb.js';
import Properties from '../component/Properties';
import UserProfile from '../component/UserProfile';
import LTIQuizPage from '../pages/LtiQuiz'; //LTI Changes
import FormLogin from './FormLogin';
import { AppSetting, AppProperties, IsPublicSite } from '../common/function';
import SearchBar from './SearchBar';
import LTIQuizMapping from '../pages/LTIQuizMapping.js';
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { AppContext } from './context/AppContext.js';
import { QuestionVectorProvider } from './context/QuestionVectorContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HelpText from '../lib/help-text';
import "./imageStyle.css";

const helpTextModel = new HelpText();


function isActive(to, path) {
  return to === path;
}
function isQuestionBankPage(baseFolder,path) {
  let questionPathUrls = ['subjects','SubCategoryDetails','subCategory','category','topics']
  for (let questionPath of questionPathUrls) {
    if (path === (baseFolder + questionPath)) {
      return true
    }
  }
}
export default class App extends Component {
  AppSetting = AppSetting()
  appProperties =  AppProperties();
  enableLogin = this.appProperties.enableLogin;
  constructor(props) {
    super(props);

    this.state = {
      userProfile: {
        givenName: '',
        role: -1,
        isLoggedIn: false,
        helpTextLoaded:false,
        isPublicSite: false,
      }
    };
  }


  componentWillMount() {
    /*helpTextModel.getAllHelpText().then(res=>{
      this.setState({helpTextLoaded:true})
    });*/
  }

  componentDidMount() {
    // Change tab title and icon only if it's SF
    if (this.AppSetting?.REACT_APP_ENABLE_LTI === false) {
      document.title = "Stem Fluency";
    
      const favIconLink = document.querySelector('link[rel="shortcut icon"]');
      favIconLink.href = './sf-favicon.ico';
    }
    this.setState({
      isPublicSite: IsPublicSite(),
    })
  }


  login = () => {
    apiRequestService({
      method: 'post',
      url: '/Login'
    }).then(token => {
      /*  console.debug('retriveuserProfile' + token);
      window.localStorage.setItem(AppSetting.REACT_APP_UNIVERSITY_SUFFIX+'-token', token.data.authtoken);
      window.localStorage.setItem('GivenName', token.data.GivenName);
      window.localStorage.setItem('UnixEpoch', token.data.UnixEpoch);
      window.localStorage.setItem('emailid', token.data.emailid);
      window.localStorage.setItem('OSUID', token.data.USER_NAME);
      window.localStorage.setItem('role', token.data.role); */
      this.appProperties.currentUserData.setUserDetails(token.data);

      this.appProperties.currentUserData.getUserDetails();
      this.setState({isLoggedIn:this.appProperties.currentUserData.hasValidData()});
    });
  };

  logout = () => {
    if (this.enableLogin) {
      apiRequestService({
        method: 'post',
        url: '/logout'
      }).then(token => {
        window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_GivenName`, '');
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_USER_NAME`,'');
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_UnixEpoch`, '');
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_emailid`, '');
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`, '');
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_token`, '');
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_loginAttemptAccess`,'');
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_syncAccess`, '');
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_timeZone`, '');

        let tempUserProfile = this.state.userProfile;
        tempUserProfile.isLoggedIn = false;
        this.setState({ userProfile: tempUserProfile });
      });
    }
  };

  //Arun Shankar - Function to Add a Value to BreadCrumb - 05/01/2018
  replaceBreadCrumb = newBreadCrumb => {
    //console.debug("replaceBreadCrumb"+JSON.stringify(newBreadCrumb));
    if (this.breadcrumbHandler != null) {
      //console.debug("this.breadcrumbHandler"+this.breadcrumbHandler);
      this.breadcrumbHandler.setState({ crumbs: newBreadCrumb });
    }
  };

  //Arun Shankar - Function to Remove a Value to BreadCrumb - 05/01/2018
  popFromBreadCrumbs = () => {
    var array = this.state.crumbs;
    array.splice(array.length - 1, 1);
    this.setState({ crumbs: array });
  };

   theme = createTheme({
      palette: {
          // mode: 'dark',
          primary: {
              main: '#bb0000',
              light: '#cc0000',
              dark: '#cc0000',
              contrastText: 'white',
          },
      },
      typography: {
          fontFamily: [
              "poppins",
          ],
          button: {
            textTransform: 'none',
            fontSize: 14,
          }
        },
        components: {
          MuiRadio: {
            styleOverrides: {
              root: {
                '.MuiSvgIcon-root': {
                  color: '#333', // color when NOT selected
                },
                '&.Mui-checked .MuiSvgIcon-root': {
                  color: '#bb0000', // color when selected
                },
              },
            },
          },
          MuiButtonBase: {
            defaultProps: {
              disableRipple: true, // Disable ripple effect for all ButtonBase components
            },
          },
          MuiButtonGroup: {
              defaultProps: {
                  disableRipple: true,
              },
          },
          MuiTextField: {
            styleOverrides: {
              root: {
                '& .MuiOutlinedInput-root': {
                  borderRadius: '6px',
                }
              }
            }
          },
          MuiButton: {
            styleOverrides: {
              root: {
                borderRadius:"4px",
                boxShadow: 'none',
                '&:hover': {
                  boxShadow: 'none',
                },
                '&:active': {
                  boxShadow: 'none',
                },
                '&:focus': {
                  boxShadow: 'none',
                },
              },
            },
        },
        },
    });
  

  render() {
    // LTI Changes Start
    const {location} = this.props;
    if(location.pathname === '/ltiQuiz'){
      // return <LTIQuizPage location={location} />
      return <LTIQuizMapping location={location} />
    }

    // LTI Changes End

    if(!this.appProperties.currentUserData.hasValidData() && this.appProperties.loginType === 'form'){
      return (
        <QuestionVectorProvider>
        <AppContext.Provider
        value={{
              isPublicSite: this.state.isPublicSite
            }}
        >
          <FormLogin/>
        </AppContext.Provider>
        </QuestionVectorProvider>
      )
    }
    
    //if(!this.state.helpTextLoaded)
    //  return <BeatLoader color='#bb0000' loading={true} size={10} />
    const {
      location: { pathname },
      children
    } = this.props;

    const navigationHeader = (
      <UserProfile
        loginType={this.appProperties.loginType}
        givenName={this.appProperties.currentUserData.GivenName}
        role={this.appProperties.currentUserData.role}
        logout={this.appProperties.currentUserData.clearSessionData}
        eqmMode={this.appProperties.eqmMode}
      />
    );

    //Style to Login LInk
    let loginLinkStyle = {
      cursor: 'pointer',
      textDecoration: 'underline',
      color: '#bb0000'
    };

    const navBgColor = this.AppSetting.REACT_APP_UNIVERSITY_FULL_NAME ? {
      backgroundColor: 'white',
      // marginTop: '48%',
      fontSize: '17px',
      fontFamily: 'Roboto',
      // height: '70%'
    } : {
      backgroundColor: 'white',
      // marginTop: '40%',
      fontSize: '17px',
      fontFamily: 'Roboto',
      // height: '70%'
    };

    let baseFolderBreadCrumb = this.appProperties.baseFolder;
    let breadcrumb = (
      <BreadCrumb 
        ref={input => {
          console.debug('Ref' + input);
          this.breadcrumbHandler = input;
        }}
        Style={isQuestionBankPage(baseFolderBreadCrumb,pathname) ? {
          marginTop: '50px'
        } : {
          marginTop: '25px'
        }}
        
      />
    );
    let appContent = (
      <p>
        <button  style={loginLinkStyle} className='ButtonLink' onClick={this.login}>Click Here{' '}</button>
        if you are not logged in automatically within 10 seconds to Login Again
      </p>
    );

    let baseFolder = this.appProperties.baseFolder;
    //Left Menu
    let navItemsArray = [
      {
        component: IndexLink,
        to: baseFolder,
        active: isActive(baseFolder, pathname),
        primaryText: 'Dashboard',
        activeBoxClassName: 'md-list--active'
      },
      {
        component: IndexLink,
        to: baseFolder + "AssignmentMatrix",
        active: isActive(baseFolder + "AssignmentMatrix", pathname),
        primaryText: 'Assignment Matrix',
        activeBoxClassName: 'md-list--active'
      },
      ...(window.location.hostname.includes("colorado") || window.location.hostname.includes("localhost")
    ? [{
        component: IndexLink,
        to: baseFolder + "Assessments",
        active: isActive(baseFolder + "Assessments", pathname),
        primaryText: 'Assessments',
        activeBoxClassName: 'md-list--active'
      }]
    : []),
      
      // {
      //   component: IndexLink,
      //   to: baseFolder + "AssignmentLibrary",
      //   active: isActive(baseFolder + "AssignmentLibrary", pathname),
      //   primaryText: 'Assignment Library',
      //   activeBoxClassName: 'md-list--active'
      // },
      {
        component: IndexLink,
        to: baseFolder + "AssignmentMatrixLibrary",
        active: pathname?.includes("AssignmentMatrixLibrary"),
        primaryText: 'Assignment Matrix Library',
        activeBoxClassName: 'md-list--active'
      },
      {
        component: Link,
        to: baseFolder + 'Courses',
        active: isActive(baseFolder + 'Courses', pathname),
        primaryText: (this.appProperties.schoolMode?'Standards':'Courses'),
        activeBoxClassName: 'md-list--active'
      },
      {
        component: Link,
        to: baseFolder + 'subjects',
        active: isActive(baseFolder + 'subjects', pathname),
        primaryText: 'Question Bank',
        activeBoxClassName: 'md-list--active'
      },
      {
        component: Link,
        to: baseFolder + 'tutorialsAndExplanations',
        active: isActive(baseFolder + 'tutorialsAndExplanations', pathname),
        primaryText: 'Tutorials & Explanations',
        activeBoxClassName: 'md-list--active'
      },
      {
        component: Link,
        to: baseFolder + 'gradebook',
        active: isActive(baseFolder + 'gradebook', pathname),
        primaryText: 'Gradebook',
        activeBoxClassName: 'md-list--active'
      },
      {
        component: Link,
        to: baseFolder + 'activityLog',
        active: isActive(baseFolder + 'activityLog', pathname),
        primaryText: 'Activity Log',
        activeBoxClassName: 'md-list--active'
      },
      {
        component: Link,
        to: baseFolder + 'profile',
        active: isActive(baseFolder + 'profile', pathname),
        primaryText: 'Profile',
        activeBoxClassName: 'md-list--active'
      },
    ];

    /*if (this.appProperties.currentUserData.role >= 2) {
      navItemsArray.push(
      {
        component: Link,
        to: baseFolder + 'archivePage',
        active: isActive(baseFolder + 'archivePage', pathname),
        primaryText: 'Archive',
        activeBoxClassName: 'md-list--active'
      });
    }*/

    if(this.appProperties.eqmMode !== true){
      navItemsArray.push(
        {
          component: Link,
          to: baseFolder + 'archivePage',
          active: isActive(baseFolder + 'archivePage', pathname),
          primaryText: 'Archive',
          activeBoxClassName: 'md-list--active'
        }
      );
      
    } 
    navItemsArray.push(
      {
        component: Link,
        to: baseFolder + 'PerfGraphs',        
        active: isActive(baseFolder + 'PerfGraphs', pathname),
        primaryText: 'Performance Analytics',
        activeBoxClassName: 'md-list--active'
      }
    );
    
    if (this.appProperties.currentUserData.syncAccess !== null && this.appProperties.currentUserData.syncAccess === '1') {
      //   navItemsArray.push(
      // {
      //   component: Link,
      //   to: baseFolder + 'synchronization',
      //   active: isActive(baseFolder + 'synchronization', pathname),
      //   primaryText: 'Synchronization',
      //   activeBoxClassName: 'md-list--active'
      // });
    }
    if (this.appProperties.currentUserData.role >= 2) {
      navItemsArray.push(
      {
        component: Link,
        to: baseFolder + 'settingsPage',
        active: isActive(baseFolder + 'settingsPage', pathname),
        primaryText: 'Settings',
        activeBoxClassName: 'md-list--active'
      });
    }

    if (this.appProperties.currentUserData.loginAttemptAccess === '1' || this.appProperties.currentUserData.role === 2) {
    navItemsArray.push(
      {
        component: Link,
        to: baseFolder + 'loginAttemptPage',
        active: isActive(baseFolder + 'loginAttemptPage', pathname),
        primaryText: 'Students',
        activeBoxClassName: 'md-list--active'
      }
     );
    }
    navItemsArray.push(
      {
        component: Link,
        to: baseFolder + 'helpMenuCat',
        active: isActive(baseFolder + 'helpMenuCat', pathname),
        primaryText: 'Help',
        activeBoxClassName: 'md-list--active'
      }
     );
     navItemsArray.push(
      {
        component: Link,
        to: baseFolder + 'AboutPage',
        active: isActive(baseFolder + 'AboutPage', pathname),
        primaryText: 'About',
        activeBoxClassName: 'md-list--active'
      }
     );

     if (this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX === 'cpanel' && (this.appProperties.currentUserData.USER_NAME === 'jith' || this.appProperties.currentUserData.USER_NAME === 'heckler')){
        navItemsArray = [
          {
            component: Link,
            to: baseFolder,
            active:isActive(baseFolder ,pathname),
            primaryText: 'Universities',
            activeBoxClassName: 'md-list--active'
          }
        ]
      }
     console.log('appProperties.currentUserData.hasValidData()',this.appProperties.currentUserData.hasValidData());
     
    if (this.appProperties.currentUserData.hasValidData() || this.enableLogin !== true) {
      appContent = (
        <NavigationDrawer
          toolbarTitle={breadcrumb}
          drawerTitle={navigationHeader}
          autoclose="true"
          //drawerStyle={drawerBgColor}
          toolbarProminent={false}
          toolbarClassName="toolbarHeader"
          navStyle={navBgColor}
          tabletDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY}
          navItems={navItemsArray}
        >
          {children
            ? React.cloneElement(children, {
                key: pathname,
                popFromBreadCrumbs: this.popFromBreadCrumbs,
                replaceBreadCrumb: this.replaceBreadCrumb
              })
            : null}
        </NavigationDrawer>
      );
    }
    const currentDate = new Date();
    const Footer = (<footer style={{textAlign:"center",bottom: "0px",width: "100%"}}>
      {this.appProperties.copyright?
      <p><span role="img" aria-label="copyRight">©️ </span> {currentDate.getFullYear()} The Ohio State University All rights reserved.</p>
      :
      <p></p>}
      </footer>);
    
    let SearchBarComponent = (
      <div>
        <div  style={{ display: isQuestionBankPage(baseFolder,pathname) ? 'block': 'none'}} >
          <SearchBar location={this.props.location}/>
        </div>
      </div>
    )
    return (
      <div>
        <ToastContainer />
        <ThemeProvider theme={this.theme}>
          <QuestionVectorProvider>
          <AppContext.Provider value={{
              isPublicSite: this.state.isPublicSite
            }}>
                <NotificationContainer />
                {SearchBarComponent}
                {appContent}
                {Footer}
          </AppContext.Provider>
          </QuestionVectorProvider>
        </ThemeProvider>
      </div>
    );
  }
}

// export default App;
